export default __webpack_public_path__ + "static/media/download-app-modal-bg.2e5595b0.png";